import React, { useContext, useState } from 'react'
import {
  Box, IcoMoon, Text, useResponsiveWrapperContext, KeyboardArrowDownIcon, KeyboardArrowUpIcon
} from '@usap/uicomponents'

import { LocalContext } from '../../../../helpers/useLocalContext'

import VehicleFitment from './VehicleFitment'
import ProductDetails from './ProductDetails'

export default function MoreAttributes(props) {
  const {
    fitNotes,
    productAttributes,
    index,
    sku,
    expandFitment,
  } = props

  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext

  const { isDesktop } = useResponsiveWrapperContext()

  const [infoFlag, setInfoFlag] = useState(isDesktop || expandFitment)

  const displayExtraInfo = infoFlag ? 'block': 'none'
  const toogleButtonId = infoFlag ? `lessInfo-${sku}-${index}` : `moreInfo-${sku}-${index}`
  const toggleButtonLabel = infoFlag ? 'Less Info': 'More Info'
  const toggleButtonIcon = infoFlag ? KeyboardArrowUpIcon : KeyboardArrowDownIcon

  return (
    <>
      <Box
        className="attributeProductFit"
        style={{ display: isBot ? 'block' : displayExtraInfo }}
      >
        <VehicleFitment
          fitNotes={fitNotes}
          index={index}
          sku={sku}
          expandFitment={expandFitment}
        />

        <ProductDetails
          productAttributes={productAttributes}
          index={index}
          sku={sku}
        />
      </Box>

      {!isDesktop && !isBot && (
        <Box
          id={toogleButtonId}
          direction="row"
          justify="center"
          align="center"
        >
          <Text
            size="xsmall"
            color="blueLink"
            onClick={() => {
              setInfoFlag(!infoFlag)
            }}
          >
            {toggleButtonLabel}
          </Text>
          <IcoMoon
            icon={toggleButtonIcon}
            color="blueLink"
            size="20px"
            onClick={() => {
              setInfoFlag(!infoFlag)
            }}
          />
        </Box>
      )}

    </>
  )
}
